/* ============================================================================
   Unified brief-form interaction. Wires up:
     - chip click → toggles .is-active and updates hidden inputs
     - multi-select chip groups (data-multi="true") accumulate comma-separated
     - "We'll route this to" live preview reflects medium + first three markets
   Run once on DOMContentLoaded. Idempotent: every form is initialised in
   isolation so multiple .bf-form blocks on one page won't cross-talk.
   ============================================================================ */

(function () {
  function initBriefForm(form) {
    if (form.dataset.bfInit === '1') return;
    form.dataset.bfInit = '1';

    var deskMap = {
      audio: 'Audio desk',
      video: 'Video desk',
      press: 'Press desk',
      ooh: 'OOH desk',
      digital: 'Digital desk',
      multi: 'Escalations desk',
      other: 'Escalations desk'
    };

    var state = { medium: null, markets: [], budget: null, timing: null };

    // Pick up pre-selected chips (server-rendered .is-active)
    form.querySelectorAll('.bf-chips').forEach(function (group) {
      var key = group.dataset.group;
      var multi = group.dataset.multi === 'true';
      group.querySelectorAll('.bf-chip.is-active').forEach(function (chip) {
        var val = chip.dataset.val;
        if (multi) {
          if (state.markets.indexOf(val) === -1) state.markets.push(val);
        } else {
          state[key] = val;
        }
      });
      syncHidden(form, key, multi ? state.markets.join(',') : state[key]);
    });

    form.querySelectorAll('.bf-chips').forEach(function (group) {
      var key = group.dataset.group;
      var multi = group.dataset.multi === 'true';
      group.querySelectorAll('.bf-chip').forEach(function (chip) {
        chip.addEventListener('click', function () {
          var val = chip.dataset.val;
          if (multi) {
            var idx = state.markets.indexOf(val);
            if (idx >= 0) { state.markets.splice(idx, 1); chip.classList.remove('is-active'); }
            else { state.markets.push(val); chip.classList.add('is-active'); }
            syncHidden(form, key, state.markets.join(','));
          } else {
            group.querySelectorAll('.bf-chip').forEach(function (c) { c.classList.remove('is-active'); });
            chip.classList.add('is-active');
            state[key] = val;
            syncHidden(form, key, val);
          }
          updateRoutePreview(form, state, deskMap);
        });
      });
    });

    // Initial paint of route preview if any pre-selection
    updateRoutePreview(form, state, deskMap);
  }

  function syncHidden(form, key, value) {
    var input = form.querySelector('input[type="hidden"][data-bf-key="' + key + '"]');
    if (input) input.value = value || '';
  }

  function updateRoutePreview(form, state, deskMap) {
    var rp = form.querySelector('.bf-route-preview');
    if (!rp) return;
    var v = rp.querySelector('.bf-route-v');
    if (!state.medium) {
      v.innerHTML = '<span class="bf-placeholder">Pick a medium above and we’ll route this to the right desk…</span>';
      rp.classList.remove('is-live');
      return;
    }
    var desk = deskMap[state.medium] || 'Planning desk';
    var market = '';
    if (state.markets.length) {
      market = ' · ' + state.markets.slice(0, 3).join(' · ');
    }
    v.innerHTML = 'Senior <em>planner</em> · ' + escapeHtml(desk) + escapeHtml(market);
    rp.classList.add('is-live');
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function start() {
    document.querySelectorAll('.bf-form').forEach(initBriefForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
